import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiPostDetailSectionDTO,
  PostDetailSectionDTO,
} from "@lib/strapi/dtos/components/sections/postDetailSection.dto";

export class PostDetailSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiPostDetailSectionDTO,
  ): Promise<PostDetailSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new PostDetailSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.showAuthor = strapiData.showAuthor;
    dto.showPublishedDate = strapiData.showPublishedDate;
    dto.showRelated = strapiData.showRelated;
    return dto;
  }
}
